import { BoxProps, Flex, Icon, Tooltip } from "@chakra-ui/react";
import React from "react";

import { IconButton } from "../../../components";
import { useSendGAEvent } from "../../../utils/googleAnalytics";
import { VideoStateControl } from "../MediaPlayer/useVideoState";
import {
  CONTROL_ACTIVE_BG,
  CONTROL_HOVER_BG,
  IconExitFullscreen,
  IconFullscreen,
  IconPictureInPicture,
} from "./theme";

type VideoFullscreenControlsV2Props = BoxProps & {
  fullScreenControls?: VideoStateControl;
  pipControls?: VideoStateControl;
  isSmallScreen?: boolean;
};

const VideoFullscreenControlsV2: React.FC<VideoFullscreenControlsV2Props> = ({
  pipControls = {
    isSupported: false,
    toggle: () => undefined,
  },
  fullScreenControls = {
    isSupported: false,
    isActive: false,
    toggle: () => undefined,
  },
  isSmallScreen = false,
  ...styles
}) => {
  const { isSupported: pipSupported, toggle: togglePictureInPicture } =
    pipControls;
  const sendGAEvent = useSendGAEvent();

  const {
    isSupported: fullscreenSupported,
    isActive: fullscreenActive,
    toggle: toggleFullscreen,
  } = fullScreenControls;

  const onFullScreen = (): void => {
    if (toggleFullscreen) {
      sendGAEvent("toggle_fullscreen", "call_review");
      toggleFullscreen();
    }
  };

  const onPipToggle = (): void => {
    if (togglePictureInPicture) {
      sendGAEvent("toggle_pip", "call_review");
      togglePictureInPicture();
    }
  };

  return (
    <Flex gap="1" alignItems="center" {...styles}>
      {pipSupported && !fullscreenActive && (
        <Tooltip label="Picture-in-picture">
          <IconButton
            bg="transparent"
            color="white"
            aria-label="Picture in picture"
            display="flex"
            pointerEvents="all"
            w={10}
            h={10}
            minW={10}
            borderRadius="full"
            _hover={{ bg: CONTROL_HOVER_BG }}
            _active={{ bg: CONTROL_ACTIVE_BG }}
            icon={<Icon as={IconPictureInPicture} color="white" boxSize="6" />}
            onClick={onPipToggle}
          />
        </Tooltip>
      )}

      {fullscreenSupported && (
        <Tooltip label={fullscreenActive ? "Exit fullscreen" : "Fullscreen"}>
          <IconButton
            bg="transparent"
            color="white"
            aria-label={fullscreenActive ? "Exit fullscreen" : "Fullscreen"}
            display="flex"
            pointerEvents="all"
            w={10}
            h={10}
            minW={10}
            borderRadius="full"
            _hover={{ bg: CONTROL_HOVER_BG }}
            _active={{ bg: CONTROL_ACTIVE_BG }}
            icon={
              <Icon
                as={fullscreenActive ? IconExitFullscreen : IconFullscreen}
                boxSize="6"
                color="white"
              />
            }
            onClick={onFullScreen}
          />
        </Tooltip>
      )}
    </Flex>
  );
};

export default VideoFullscreenControlsV2;
